export default __webpack_public_path__ + "static/media/Prathamesh_Apte.14d59460.jpg";